// window.gsap = require('gsap/dist/gsap');

// import gsap from 'gsap';
// console.log(gsap); // Verifica que gsap se haya cargado

// import {gsap, TweenMax, TimelineLite} from 'gsap';

import gsap from 'gsap/dist/gsap';

window.gsap = gsap;
